import React, { useEffect, useMemo, useState } from "react";
import {
  SET_RESULT_ARRAY,
  SelecrSeriesStore, SET_SERIES_TYPE, SelectSeriesType, SelectSeriesTypeDisableFlag
} from "../../../../redux/2d-slice/seriesSlice2d";
import { useDispatch, useSelector } from "react-redux";
import { selectAdvaceTimeSlotCount } from "../../../../redux/seriesSlice";
import Checkbox from "../../checkbox/Checkbox";

function RightResultContainer() {
  const dispatch = useDispatch();

  const seriesStore = useSelector(SelecrSeriesStore);
  let seriesType = useSelector(SelectSeriesType);
  let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag);
  const advaceTimeSlotCount = useSelector(selectAdvaceTimeSlotCount);
  const [totalCount, setTotalCount] = useState(0);

  // 👉 Calculate result array
  const resultArray = useMemo(() => {
    return seriesStore.map((series) =>
      series.seriesAllfield.map((field) => {
        let total = 0;
        field.forEach((number) => {
          const value = Number(number.getFinalValue());
          total += value;
        });
        return Math.floor(total);
      })
    );
  }, [seriesStore]);

  // 👉 Calculate merged total per row (sum of 10, 30, 50)
  const mergedResultArray = useMemo(() => {
    if (!Array.isArray(resultArray) || resultArray.length === 0) return Array(10).fill(0);

    const merged = Array(10).fill(0);
    resultArray.forEach((series) => {
      series.forEach((val, idx) => {
        merged[idx] += Number(val ?? 0);
      });
    });
    return merged;
  }, [resultArray]);

  // 👉 Dispatch + total count
  useEffect(() => {
    if (Array.isArray(resultArray)) {
      dispatch(SET_RESULT_ARRAY(resultArray));
      const total = mergedResultArray.reduce((sum, val) => sum + val, 0);
      setTotalCount(Math.floor(total));
    }
  }, [resultArray, mergedResultArray, dispatch]);

  const POINT_MULTIPLIER = 2;

  const rowColors = [
      "#cb4a18",
      "#f3a413",
      "#fbcf20",
      "#ebc81e",
      "#9eb119",
      "#f6b656",
      "#f4b19c",
      "#f099a2",
      "#eda0ba",
      "#FE504F"
    ];

  return (
    <table className="desk_qty_table" border="1" cellSpacing="0" cellPadding="0" style={{ borderCollapse: 'collapse' }}>
      <tbody>
        {/* header */}
        <tr colSpan={2}>
          <table border="1" cellSpacing="0" cellPadding="0" style={{ borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td className="checkbox_container flex items-center float-left">
                  {[
                    { type: 'Family', color: '#d65d16' },
                    { type: 'Cross', color: '#a5af1c' },
                    { type: 'Box25', color: '#eda3ba' }
                  ].map((item, index) => {
                    return (
                      <span
                        key={index}
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          backgroundColor: item.color,
                          padding: '5px',
                        }}
                      >
                        <React.Fragment key={index}>
                          <Checkbox
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              backgroundColor: item.color,
                              padding: '5px',
                            }}
                            checked={seriesType === item.type}
                            id={item.type}
                            onChange={(e) => {
                              if (e.target.checked) {
                                dispatch(SET_SERIES_TYPE(item.type))
                              } else {
                                dispatch(SET_SERIES_TYPE('All'))
                              }
                            }}
                            disabled={seriesTypeDisableFlag} />
                          <label className="checkbox_label">{item.type}</label>
                        </React.Fragment>
                      </span>
                    )
                  })}
                </td>
              </tr>
            </tbody>
          </table>
        </tr>
        <tr height={'100%'} colSpan={2} className="text-center">
          <table width="100%" border="1" cellSpacing="0" cellPadding="0" style={{ borderCollapse: 'collapse' }}>
            <tbody>
              <tr style={{backgroundColor:"#da5d25"}}>
                <td height={'30px'} style={{ color: 'white', textAlign: 'center', border: '1px solid #000' }}>
                  Qty
                </td>
                <td height={'30px'} style={{ color: 'white', textAlign: 'center', border: '1px solid #000' }}>
                  <div className="">Point</div>
                </td>
              </tr>
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((row) => {
                const hasValue = Number(mergedResultArray[row]) > 0;

                return (
                  <tr height="30px" key={row} className="text-center">
                    <td
                      height="30px"
                      style={{
                        color: "black",
                        textAlign: "center",
                        backgroundColor: hasValue ? "#d96414" : "#f2d18c",
                        border: "1px solid #000",
                      }}
                    >
                      <div className="qty_series_no_val_main">
                        <div className="qty_series_no_val double_qty_div">
                          {mergedResultArray[row]}
                        </div>
                      </div>
                    </td>

                    <td
                      height="30px"
                      style={{
                        color: "black",
                        textAlign: "center",
                        backgroundColor: hasValue ? "#d96414" : "#f2d18c",
                        border: "1px solid #000",
                      }}
                    >
                      <div className="qty_series_no_val_main">
                        <div className="qty_series_no_val double_amt_div">
                          {mergedResultArray[row] * POINT_MULTIPLIER}
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}

              <tr className="qty_res_total_sec">
                <td height={'30px'} style={{ color: 'black', textAlign: 'center', backgroundColor: '#98390b',color:'#ffcdb0',  fontWeight: '900', border: '1px solid #000' }}>
                  <div className="qty_series_no_val">
                    {advaceTimeSlotCount ? advaceTimeSlotCount * totalCount : totalCount}
                  </div>
                </td>
                <td height={'30px'} style={{ color: 'black', textAlign: 'center', backgroundColor:' #98390b', color:'#ffcdb0', fontWeight: '900', border: '1px solid #000' }}>
                  <div className="qty_series_no_val">
                    {advaceTimeSlotCount
                      ? advaceTimeSlotCount * totalCount * POINT_MULTIPLIER
                      : totalCount * POINT_MULTIPLIER}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </tr>

        {/* rows 0-9 */}

        {/* total */}

      </tbody>
    </table>
  );
}

export default RightResultContainer;
